import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectPodcastFollowersStatus, selectDateRange } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, DateRangeWithLabel, Follower } from '../types';

export const loadPodcastFollowers = (podcastId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'podcastFollowers';

  const { startDate, endDate } = selectDateRange(getState()) as DateRangeWithLabel;
  const endpoint = `${PODCASTERS_SERVICE}/v0/shows/${podcastId}/followers?start=${startDate}&end=${endDate}`;

  /* istanbul ignore next */
  if (selectPodcastFollowersStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_PODCAST_FOLLOWERS_REQUEST'));

  try {
    const { counts: data }: { counts: Follower[] } = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_PODCAST_FOLLOWERS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_PODCAST_FOLLOWERS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
